import { getEndpoint } from "@api-routes/endpoint";
import { OFFER_CONFIG } from "@constants";

const MNP_FACADE_MS_NAME = "mnp-facade";
export const GET_PORT_IN_SLOT_ROUTE = `${getEndpoint(MNP_FACADE_MS_NAME)}ref-port-days/${OFFER_CONFIG.BRAND}/${
    OFFER_CONFIG.CHANNEL
}`;

export const getPortinRoute = (serviceId: number) =>
    `${getEndpoint(MNP_FACADE_MS_NAME)}ports/service/${serviceId}/uncompleted`;

export const getMobileNumberPortRoute = (phoneNumber: string) =>
    `${getEndpoint(MNP_FACADE_MS_NAME)}ref-networks/${phoneNumber}/operator`;

export const PORT_IN_ROUTE = `${getEndpoint(MNP_FACADE_MS_NAME)}/ports`;
